import React, { useEffect } from 'react';

import { GeneralThemesTooltip } from '@ps-int/general-themes-components/components';
import { ExternalContext } from '@ps-int/general-themes-components/contexts';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../helpers/i18n';
import { countMetrika } from '../../../../helpers/metrika';
import { isMobileUa } from '../../../uatraits/selectors';
import { useGeneralThemesSettingsDatasyncService } from '../../hooks/useGeneralThemesSettingsDatasyncService';
import { SectionComponentType } from '../../types';
import { useGeneralThemesI18n } from '../theme-locales/useGeneralThemesI18n';
import ThemeSelectionGrid from '../theme-selection-grid';
import VideoBgSwitchWrapper from '../video-bg-switch-wrapper';
import css from './theme.css';

const ThemeSection: SectionComponentType = ({ drawerRef }) => {
    const { i18n: gtI18n } = useGeneralThemesI18n();
    const ds = useGeneralThemesSettingsDatasyncService();
    const isMobile = useSelector(isMobileUa);

    useEffect(() => {
        countMetrika('interface elements', 'settings popup', 'show');
    }, []);

    return (
        <ExternalContext.Provider value={{ i18n: gtI18n }}>
            <h3 className={css.Title}>
                {i18n('settings', 'theme-title')}
                <GeneralThemesTooltip scope={drawerRef} />
            </h3>
            <ThemeSelectionGrid ds={ds} />
            {!isMobile && <VideoBgSwitchWrapper ds={ds} />}
        </ExternalContext.Provider>
    );
};

export default ThemeSection;
